import React, { Component } from 'react'
import { Card, Row, Col, Alert } from 'reactstrap'
import { LicensesSidebar, LicensesCardRouter } from './'
import getAllDistrictsAndSchools from '../../../helpers/users/licenses/getAllDistrictsAndSchools';
import { BeatLoader } from 'react-spinners'
import superAdmin from '../../../helpers/users/testing/superAdminUser'
import devMode from '../../../config/devMode'
import { connect } from 'react-redux'

class Licenses extends Component {
  // fetch all educators, all students, all districts, all schools, all licenses
  // or maybe on demand? if on demand, should prob still get all districts and schools
  
  // get all schools and districts here. Get applicable educators/students/licenses at next level

  state = {
    loading: false,
    error: '',
    districts: null,
    schools: null,
  }

  componentDidMount() {
    this.setState({loading: true})
    getAllDistrictsAndSchools()
      .then(({districts, schools}) => {
        this.setState({
          loading: false,
          error: '',
          districts,
          schools,
        })
      })
      .catch(error => this.setState({loading: false, error}))
  }

  

  render() {
    const { loading, error, districts, schools, } = this.state
    let { user } = this.props
    if (devMode) user = superAdmin    
    return (
      <Card className='manage-users-container'>
         { user && user.role === "Super Administrator" ? <Row noGutters>
       <Col className='manage-users-sidebar' xs='12' lg='2'>
            <LicensesSidebar />
          </Col>
          <Col className='manage-users-content' xs='12' lg='10'>
            {!loading && !error && districts && schools &&
              <LicensesCardRouter {...{...this.props, districts, schools, user}}/>
            }
            <BeatLoader loading={loading}/>
            {error && <Alert>{error}</Alert>}
          </Col>
          </Row> : <Row className="p-5"><Col><Alert color="danger">Sorry! Your account does not have permission to access this page.</Alert></Col></Row> }
      </Card>
    )
  }
}

export default connect(
  state => ({
    user: state.users.testUser,
  })
)(Licenses)




// WEBPACK FOOTER //
// ./src/components/Users/Licenses/Licenses.js